import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import ProductGrid from './components/ProductGrid';
import BuildSetup from './components/BuildSetup';
import ComparisonTable from './components/ComparisonTable';
import Bundles from './components/Bundles';
import FAQ from './components/FAQ';
import Footer from './components/Footer';
import CartDrawer from './components/CartDrawer';
import { CartProvider } from './context/CartContext';

function App() {
  return (
    <CartProvider>
      <div className="min-h-screen bg-slate-50 font-sans text-slate-900 selection:bg-indigo-200 selection:text-indigo-900 overflow-x-hidden">
        <Header />
        <main>
          <Hero />
          <ProductGrid />
          <BuildSetup />
          <ComparisonTable />
          <Bundles />
          <FAQ />
        </main>
        <Footer />
        <CartDrawer />
      </div>
    </CartProvider>
  );
}

export default App;